import React from "react";
import ModalidadesImages from "../components/ModalidadesImages";
import {
  FaCheck,
  FaWhatsapp,
  FaDumbbell,
  FaClock,
  FaStar,
} from "react-icons/fa";
import Seo from "../seo/Seo";
import { seoConfig } from "../seo/seoConfig";
import "../css/Modalidades.css";

const Modalidades = () => {
  return (
    <div className="modalidades-page">
      <Seo {...seoConfig.modalidades} />
      {/* Hero Section */}
      <section className="modalidades-hero">
        <div className="container">
          <div className="section-header">
            <span className="section-tag">Exercício & Bem-estar</span>
            <h1>MODALIDADES</h1>
            <p className="section-description">
              Descubra as nossas modalidades de treino e encontre a que melhor
              se adapta aos seus objetivos. Profissionais certificados e
              ambiente acolhedor.
            </p>
          </div>
        </div>
      </section>

      {/* Modalidades Grid */}
      <section className="modalidades-section">
        <div className="container">
          <ModalidadesImages />
        </div>
      </section>

      {/* Packs Section */}
      <section className="packs-section">
        <div className="container">
          <div className="section-header">
            <span className="section-tag">Os Nossos Packs</span>
            <h2>Escolha o Plano Ideal para Si</h2>
            <p className="section-description">
              Oferecemos diferentes opções para se adaptar ao seu estilo de vida
              e objetivos.
            </p>
          </div>

          <div className="packs-grid">
            {/* Pack Sala de Exercícios */}
            <div className="pack-card">
              <div className="pack-icon">
                <FaDumbbell />
              </div>
              <h3>Sala de Exercícios</h3>
              <p className="pack-description">
                Utilização livre da Sala de Exercício, mediante marcação prévia.
              </p>
              <ul className="pack-features">
                <li>
                  <FaCheck /> Acesso à sala equipada
                </li>
                <li>
                  <FaCheck /> Marcação flexível
                </li>
                <li>
                  <FaCheck /> Ambiente personalizado
                </li>
              </ul>
            </div>

            {/* Pack Life */}
            <div className="pack-card featured">
              <div className="pack-badge">Mais Popular</div>
              <div className="pack-icon">
                <FaStar />
              </div>
              <h3>Pack Life</h3>
              <p className="pack-description">
                Treino em pequeno grupo, no horário do almoço, 3 vezes por
                semana.
              </p>
              <ul className="pack-features">
                <li>
                  <FaCheck /> 3 sessões semanais
                </li>
                <li>
                  <FaCheck /> Grupos reduzidos (até 6 pessoas)
                </li>
                <li>
                  <FaCheck /> Horário de almoço
                </li>
                <li>
                  <FaCheck /> Acompanhamento de profissional certificado
                </li>
              </ul>
            </div>

            {/* Pack Power */}
            <div className="pack-card">
              <div className="pack-icon">
                <FaDumbbell />
              </div>
              <h3>Pack Power</h3>
              <p className="pack-description">
                Combinação semanal de treino personalizado com Pilates em grupo.
              </p>
              <ul className="pack-features">
                <li>
                  <FaCheck /> 1 treino personalizado por semana
                </li>
                <li>
                  <FaCheck /> 2 aulas de Pilates em grupo por semana
                </li>
                <li>
                  <FaCheck /> Plano adaptado aos seus objetivos
                </li>
              </ul>
            </div>

            {/* Aulas Avulsas */}
            <div className="pack-card">
              <div className="pack-icon">
                <FaClock />
              </div>
              <h3>Aulas Avulsas</h3>
              <p className="pack-description">
                Flexibilidade total para experimentar qualquer aula à sua
                escolha.
              </p>
              <ul className="pack-features">
                <li>
                  <FaCheck /> Qualquer aula de grupo
                </li>
                <li>
                  <FaCheck /> Sem compromisso
                </li>
                <li>
                  <FaCheck /> Pagamento por aula
                </li>
              </ul>
            </div>

            {/* Pack Treino Personalizado */}
            <div className="pack-card">
              <div className="pack-icon">
                <FaDumbbell />
              </div>
              <h3>Treino Personalizado</h3>
              <p className="pack-description">
                Acompanhamento exclusivo adaptado às suas necessidades.
              </p>
              <ul className="pack-features">
                <li>
                  <FaCheck /> 8 aulas de 30' ou 60'
                </li>
                <li>
                  <FaCheck /> Profissionais certificados
                </li>
                <li>
                  <FaCheck /> Plano individualizado
                </li>
                <li>
                  <FaCheck /> Avaliação física incluída
                </li>
              </ul>
            </div>
          </div>

          {/* CTA */}
          <div className="packs-cta">
            <a
              href={`https://wa.me/+351962281179?text=${encodeURIComponent("Olá! Gostaria de saber mais sobre os packs de treino.")}`}
              target="_blank"
              rel="noopener noreferrer"
              className="cta-button primary large"
            >
              <FaWhatsapp /> Fale Connosco
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Modalidades;
